import { NotificationActions } from 'rhinostyle';
import {
  MAX_FACEBOOK_FILE_SIZE,
  MAX_MMS_FILE_SIZE,
  MAX_STANDARD_FILE_SIZE,
  MIME_TYPE_APPLICATION_PDF,
  THUMBNAIL_FILE_EXTENSIONS,
} from '../constants/AppConstants';
import {
  TYPE_IMAGE_BMP,
  TYPE_IMAGE_GIF,
  TYPE_IMAGE_JPEG,
  TYPE_IMAGE_JPG,
  TYPE_IMAGE_PNG,
} from '../constants/Types';
import { UploadActions } from '../actions';
import WebSocketService from '../services/WebSocketService';

export function findNonViableAttachmentsForMMS(attachment) {
  const isPdf = (attachment.type.name || attachment.type) === MIME_TYPE_APPLICATION_PDF;
  const isTooLarge = attachment.bytes > MAX_MMS_FILE_SIZE;

  return isTooLarge || isPdf;
}

export function processAttachments(attachments) {
  return attachments.map(attachment => ({
    type: attachment.type.name ? attachment.type.name : attachment.type,
    bytes: attachment.bytes,
    attachmentUrl: attachment.attachmentUrl,
    name: attachment.name,
  }));
}

export function handleAddFile(
  {
    file,
    currentAttachments = [],
    standard = true,
    secureMode = false,
    facebookChannelSelected = false,
    isTemplateUpload = false,
    bucket = process.env.REACT_APP_STANDARD_BUCKET,
    progressCallback = null,
  },
  callback,
) {
  const filename = file?.name;
  const pdfSupported = secureMode || facebookChannelSelected || standard;
  const maxNonstandardFileSize = facebookChannelSelected ? MAX_FACEBOOK_FILE_SIZE : MAX_MMS_FILE_SIZE;
  const maxSize = standard ? MAX_STANDARD_FILE_SIZE : maxNonstandardFileSize;
  const extension = filename.split('.').pop().toLowerCase();
  // template attachments have no file size limits (large ones are turned into sharelinks)
  if (file?.size >= maxSize) {
    let sizeLimit;
    if (facebookChannelSelected) {
      sizeLimit = '25 MB';
    } else if (standard) {
      sizeLimit = '5 GB';
    } else {
      sizeLimit = '600 KB';
    }
    rejectUpload(`The file you selected is too large. The maximum file size is ${sizeLimit}`);
  } else if (!pdfSupported && extension === 'pdf' && !isTemplateUpload) {
    rejectUpload('The file type you selected is not allowed to be uploaded at this time.');
  } else {
    UploadActions.uploadFile(file, bucket, filename, progressCallback)
      .then((attachment) => {
        currentAttachments.push({
          key: attachment.key,
          attachmentUrl: attachment.file,
          type: attachment.fileType,
          name: file.name,
          bytes: attachment.bytes,
          isPostProcessingNeeded: isThumbnailGenerated(extension),
        });

        // Subscribe to thumbnail generation
        WebSocketService.updateSubscriptions([
          ...WebSocketService.subscriptions,
          WebSocketService.shapeSubscriptionForFileUploadPostProcessingEvents({ bucket, key: attachment.key }),
        ]);
      })
      .finally(() => {
        callback({ attachments: currentAttachments });
      });
  }

  function rejectUpload(body) {
    NotificationActions.addNotification({
      body,
      type: 'danger',
    });

    callback({ attachments: currentAttachments });
  }
}

export function fileTypeMustBeSharelink(typeId) {
  const acceptableAttachmentTypes = [TYPE_IMAGE_BMP, TYPE_IMAGE_GIF, TYPE_IMAGE_JPEG, TYPE_IMAGE_JPG, TYPE_IMAGE_PNG];
  return !acceptableAttachmentTypes.includes(typeId);
}

export function shouldBeSharelink({ attachment, standardFileSize = true, isFacebook = false }) {
  const maxNonStandardFileSize = isFacebook ? MAX_FACEBOOK_FILE_SIZE : MAX_MMS_FILE_SIZE;
  return (!standardFileSize && attachment.bytes > maxNonStandardFileSize) || fileTypeMustBeSharelink(attachment.type.id);
}

function isThumbnailGenerated(extension) {
  return THUMBNAIL_FILE_EXTENSIONS.includes(extension);
}
